<template>
	<label class="check-box-div" @click="selfClick">
		<span class="iconfont check-box" :style="'color:'+color+';font-size:'+size+'px;'" :class="{'icon-check_box_px_rounded':isSelect,'icon-checkboxoutlineblank':!isSelect}"></span>
		<span class="check-box-label font-65">{{label}}</span>
	</label>
</template>

<script>
	export default {
		name: 'xhyCheckBox',
		/**
		 * 显示的名称 对应的数值  是否选中
		 */
		props: {
			size:{
				type: [Number,String],
				default: 25
			},
			color: {
				type: String,
				default: '#00FF00'
			},
			label: {
				type: String,
				default: ''
			},
			checked: {
				type: Boolean,
				default: false
			},
			value: {
				type: [String, Boolean],
				default: ''
			},
			readonly:{
				type:Boolean,
				default:false
			}
		},
		inject: ['xhyCheckBoxGroup'],
		data() {
			return {
				isSelect: false
			}
		},
		created() {
			this.isSelect = this.checked;
		},
		methods: {
			/**
			 * 当前点击，向上级传递数据
			 */
			selfClick() {
				if(this.readonly){
					return;
				}
				this.isSelect = !this.isSelect;
				this.xhyCheckBoxGroup.setChildStatus({
					isSelect:this.isSelect,
					value:this.value===''?this.label:this.value
				});
			},
			setRadioStatus(status) {
				this.isSelect = status;
			}
		}
	}
</script>

<style scoped>
	@import url("../../../static/xhy-check-box/xhy-iconfont.css");

	.check-box-div {
		width: 50%;
		margin-top:.6rem;
		display: inline-flex;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.check-box{
		width: .8rem;
		height: .8rem;
		margin: .2rem .6rem 0 0;
		display: inline-block;
	}
	.check-box-label{
		width: calc(100% - 1.5rem);
		line-height: 1.2rem;
		font-size: .8rem;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// src/components/xhy-check-box/xhy-check-box.vue